import React from 'react';
import { Image, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import ProfileBreadcrumb from '../shared/ProfileBreadcrumb';
import Icons from 'components/atoms/Icons';
import { ClinicalFocus } from 'components/types/ClinicalFocusTypes';
import { LocationItem } from 'components/types/LocationTypes';

type ProviderHeroProps = {
	img: ImageField;
	name: string;
	degrees: string;
	specialties?: Array<string>;
	clinicalFocus: Array<ClinicalFocus>;
	rating: number;
	reviewCount: number;
	accepting: boolean;
	locations: Array<LocationItem>;
};

const ProviderHero = (props: ProviderHeroProps): JSX.Element => {
	const cities = new Set<string>();
	props.locations?.forEach((location) => {
		cities.add(location?.fields?.City?.value);
	});
	return (
		<div className="overhauled">
			<div className="bg-secondary provider-hero">
				<div className="top-section jss-inner-container">
					<ProfileBreadcrumb name="breadcrumb" />
					<div className="hero-inner" itemScope itemType="http://schema.org/Physician">
						<div className="profile-image">
							<Image field={props?.img} height="auto" width="auto" />
						</div>
						<div className="result-top">
							<div className="result-details">
								<h3 className="result-name" itemProp="name">
									{props?.name + ', ' + props?.degrees}
								</h3>
								{props?.specialties && props?.specialties?.length > 0 ? (
									<div className="specialties">
										<p className="header">Specialty: </p>

										{props?.specialties &&
											props?.specialties.map((specialty, index) => {
												return (
													<div
														className="specialty"
														itemProp="medicalSpecialty"
														itemScope
														itemType="https://schema.org/medicalSpecialty"
														key={`specialty-${index}`}
													>
														<div
															itemProp="code"
															itemScope
															itemType="https://schema.org/MedicalCode"
														>
															<p itemProp="description">
																{specialty}
																{props?.specialties &&
																	props?.specialties?.length > 1 &&
																	index != props?.specialties.length - 1 &&
																	', '}
															</p>
														</div>
													</div>
												);
											})}
									</div>
								) : (
									''
								)}
								{props?.clinicalFocus && props?.clinicalFocus?.length > 0 ? (
									<div className="clinical-focuses">
										<p className="header">Clinical area of focus: </p>
										{props?.clinicalFocus.map((focus, index) => {
											return (
												<div
													className="clinical-focus"
													itemProp="medicalSpecialty"
													itemScope
													itemType="https://schema.org/medicalSpecialty"
													key={`focus-${index}`}
												>
													<p itemProp="description">
														{focus.name}
														{props?.clinicalFocus.length > 1 &&
															index != props?.clinicalFocus.length - 1 &&
															', '}
													</p>
												</div>
											);
										})}
									</div>
								) : (
									''
								)}
								{props?.rating && props?.rating > 0 ? (
									<div className="ratings">
										<div
											className="rating-stars"
											ie-style={`--rating: ${props?.rating}`}
											title={`This provider is rated ${props?.rating} out of 5.`}
											aria-label={`This provider is rated ${props?.rating}out of 5.`}
											style={{ '--rating': props?.rating } as React.CSSProperties}
										>
											<div className="star">
												<span className="icon icon-star">
													<Icons id="star" />
												</span>
												<div className="star-fill">
													<span className="icon icon-star">
														<Icons id="star" />
													</span>
												</div>
											</div>
										</div>
										<a href="#ratings" className="average-rating">
											{props?.rating} ({props?.reviewCount})
										</a>
									</div>
								) : (
									''
								)}
								{cities && cities?.size > 0 ? (
									<a href="#locations" className="locations">
										<span className="icon icon-location">
											<Icons id="location" />
										</span>
										<p>Office Locations:</p>
										{Array.from(cities)?.map((city, index) => {
											return (
												<div className="city" key={`city-${index}`}>
													<div>
														<p>
															{` ${city}`}
															{index != cities.size - 1 && ','}
														</p>
													</div>
												</div>
											);
										})}
									</a>
								) : (
									''
								)}
								{props?.accepting ? (
									<div className="new-patient">
										<p className="new-patient-text">Accepting New Patients</p>
									</div>
								) : (
									''
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProviderHero;
